export default __webpack_public_path__ + "static/media/sidebarBackground.1cfa27b1.svg";